import { useEffect, useState } from "react";
import { fetchData, GET_ALL_MOVIE_RATING, GET_ALL_MOVIE_RESOURCE } from "../../components/Service";
import { Link } from "../../../node_modules/react-router-dom/dist/index";
import { scrollTop } from "../../components/Helper";

const MovieReviews = () => {
	const [list, setList] = useState([]);
	const [pageUrl, setPageUrl] = useState();
	const [notFound, setNotFound] = useState(false);
	const [resourceData, setResourceData] = useState([]);

	const getList = () => {
		fetchData(pageUrl ? pageUrl : GET_ALL_MOVIE_RATING, "GET", "", false, false, (res) => {
			if (res.status) {
				setNotFound(false);
				setList(res?.data);
			} else {
				setNotFound(true);
				setList([]);
			}
		});
	};

	const getMovieResource = () => {
		fetchData(GET_ALL_MOVIE_RESOURCE, "GET", "", false, false, (res) => {
			if (res.status) {
				setResourceData(res?.data);
			} else {
				console.log(res);
			}
		});
	};

	useEffect(() => {
		scrollTop();
		getList();
	}, [pageUrl]);

	useEffect(() => {
		scrollTop();
		getMovieResource();
	}, []);

	return (
		<div className="col-lg-12">
			<div className="card card-forum">
				<div className="card-header usa-bg">
					<div className="national-bg">
						<div className="row d-flex align-items-center ind1">
							<div className="col-lg-12">
								<h4 className="text-white d-flex mb-0 py-2">Movie Reviews</h4>
							</div>
						</div>
					</div>
				</div>
				<div className="card-body bg-white p-1">
					<div className="row">
						{list?.data &&
							list?.data?.length > 0 &&
							list?.data?.map((item) => {
								let ratings = JSON.parse(item?.rating_data);
								return (
									<div key={item.id} className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-6 event_n align-self-stretch mb-1">
										<Link to={`/movie-reviews/${item.id}`} state={{ movie_review: item, resource_data: resourceData }} className="text-white">
											<div
												className="card-grid-2 hover-up h-100 mb-0"
												style={{ background: `linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)), url(${item.image})`, backgroundSize: "cover" }}
											>
												<div className="card-block-info position-relative">
													<h5 className="movie-name text-white">{item.name}</h5>
													<div className="rate mt-2">
														<input type="radio" id={`star${item.id}5`} name={`star${item.id}5`} disabled value="5" checked={item.average_rating >= 5} />
														<label htmlFor={`star${item.id}5`} title="text">
															5 stars
														</label>
														<input type="radio" id={`star${item.id}4`} name={`star${item.id}4`} disabled value="4" checked={item.average_rating >= 4} />
														<label htmlFor={`star${item.id}4`} title="text">
															4 stars
														</label>
														<input type="radio" id={`star${item.id}3`} name={`star${item.id}3`} disabled value="3" checked={item.average_rating >= 3} />
														<label htmlFor={`star${item.id}3`} title="text">
															3 stars
														</label>
														<input type="radio" id={`star${item.id}2`} name={`star${item.id}2`} disabled value="2" checked={item.average_rating >= 2} />
														<label htmlFor={`star${item.id}2`} title="text">
															2 stars
														</label>
														<input type="radio" id={`star${item.id}1`} name={`star${item.id}1`} disabled value="1" checked={item.average_rating >= 1} />
														<label htmlFor={`star${item.id}1`} title="text">
															1 star
														</label>
													</div>
													<div className="table-responsive">
														<table className="table test-white  mb-0  table-borderless table-sm">
															<tbody>
																{resourceData?.slice(0, 5)?.map((item, index) => (
																	<tr key={item.id}>
																		<td className="p-0 text-white font14">{item?.name}:</td>
																		<td className="p-0 text-white font14">{ratings[item.id] && ratings[item.id][0] ? ratings[item.id][0] : 0}</td>
																	</tr>
																))}
															</tbody>
														</table>
													</div>
												</div>
											</div>
										</Link>
									</div>
								);
							})}
						{notFound && <div className="text-center h6 text-danger py-3">No Records Found!</div>}
					</div>
					{list?.data && (
						<nav className="pt-3">
							<ul className="pagination justify-content-end">
								<li className={`page-item ${list.prev_page_url ? "" : "disabled"}`}>
									<button type="button" className="page-link" onClick={() => setPageUrl(list.prev_page_url)}>
										<span aria-hidden="true">&laquo;</span> Previous
									</button>
								</li>
								<li className={`page-item ${list.next_page_url ? "" : "disabled"}`}>
									<button type="button" className="page-link" onClick={() => setPageUrl(list.next_page_url)}>
										Next <span aria-hidden="true">&raquo;</span>
									</button>
								</li>
							</ul>
						</nav>
					)}
				</div>
			</div>
		</div>
	);
};

export default MovieReviews;
